module.exports = __webpack_public_path__ + "static/assets/b60db09353ca5b9922dc475a6134740c.svg";